var render = function render(){var _vm=this,_c=_vm._self._c;return _c('html',[_c('Header'),_c('body',[_c('div',{staticClass:"page-holder"},[_c('Navbar'),_vm._t("default"),_c('Footer'),_c('link',{attrs:{"rel":"stylesheet","href":"https://use.fontawesome.com/releases/v5.7.1/css/all.css","integrity":"sha384-fnmOCqbTlWIlj8LyTjo7mOUStjsKC4pOpQbqyi7RrhN7udi9RwhKkMHpvLbHG9Sr","crossorigin":"anonymous"}})],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }